module.exports = __webpack_public_path__ + "static/img/logo.cebd19b2.png";